<!-- <div class="year-input" (mouseover)="toggleArrows(true)" (mouseout)="toggleArrows(false)">
<div class="arrow-top" [ngClass]="{'arrow-hidden': !showArrows}" (click)="incrementYear(1)">
  <fa-icon icon="chevron-up"></fa-icon>
</div>
<span class="year">{{ year }}</span>
<div class="arrow-down" [ngClass]="{'arrow-hidden': !showArrows}" (click)="incrementYear(-1)">
  <fa-icon icon="chevron-down"></fa-icon>
</div>
</div> -->

<nb-select id="year" name="year" [(ngModel)]="year" class="year-select" (ngModelChange)="changeYear($event)">
  @for (y of yearsAvailable; track y) {
    <nb-option [value]="y">{{ y }}</nb-option>
  }
</nb-select>
